<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CwdvLc/tc-custom/9780253019844.jpg?1718169686327" alt="This image is the cover for the book Comrade Huppert"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Comrade Huppert
      </h1>
      <p class="bookDescription body article font2">
        <b>This biography of a twentieth-century poet “deftly trac[es] Hugo Huppert’s improbable path from Jewish Galicia to Soviet Moscow to postwar Vienna” (<i>Choice</i>).</b><br/><br/>After discovering the autobiography of the Austrian communist and writer Hugo Huppert (1902–1982), historian George Huppert became absorbed in the life and work of this man, a Jew, perhaps a relative, who was born a few months after George’s father and grew up just miles away. Hugo seemed to embody a distinctly central European experience of his time, of people trapped between Hitler and Stalin.<br/><br/>Using the unvarnished account found in Hugo’s notebooks, George Huppert takes the reader on a tour of the writer’s life from his provincial youth to his education and radicalization in Vienna; to Moscow, where he meets Mayakovski and is imprisoned during Stalin’s purges; through the difficult war years and return to Vienna; to his further struggles with the communist party and his blossoming as a writer in the 1950s.<br/><br/>Through all the twists and turns of this story, George remains a faithful presence, guiding the way and placing Hugo’s remarkable life in context. <i>Comrade Huppert</i> is a story of displacement and exile, the price of party loyalty, and the toll of war and terror on the mind of this emblematic figure.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        George Huppert
      </h2>
      
      <p class="authorDescription body article"><P>George Huppert is Professor of History Emeritus at the University of Illinois at Chicago and author of several books, including The Idea of Perfect History: Historical Erudition and Historical Philosophy in Renaissance France; The Style of Paris: Renaissance Origins of the French Enlightenment (IUP, 1999); After the Black Death: A Social History of Early Modern Europe (IUP, 1986); and Les Bourgeois Gentilshommes: An Essay on the Definition of Elites in Renaissance France.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?11ef1854